<template>
    <div v-if="loaded">
        <router-view :apiUrl="apiUrl" :fields="fields" :moduleName="moduleName" :loaded="loaded" :formClass="formClass" :listLink="listLink" v-on:updateTitle="updateTitle" :module="module"></router-view>
    </div>
</template>

<script>
export default {
  name: 'Custom',
  data () {
    return {
      apiUrl: '',
      fields: [],
      url: '',
      moduleName: '',
      module: '',
      listLink: '',
      loaded: 0,
      panels: [],
      formEdit: 'formEdit',
      action: '',
      formClass: 'm-form m-form--state'
    }
  },
  methods: {
    updateTitle (variable) {
      this.$emit('updateTitle', variable)
    }
  },
  created: function () {
    let ep = JSON.parse(localStorage.getItem('endpoints'))

    for (let it in ep.routes) {
      if (ep.routes[it] === '/' + this.$route.params.module) {
        this.apiUrl = ep.services[it] + '/' + process.env.API_ENDPOINT + '/admin/' + this.$route.params.module
      }
    }

    this.$http
      .get(process.env.API_URL + `/api/v1/admin/module-builder/show-by-url/${this.$route.params.module}`, {
        'headers': {
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'language': this.$store.state.loading.language
        }
      }).then(res => {
        if (res.data && res.data.data !== 'undefined') {
          let ep = JSON.parse(localStorage.getItem('endpoints'))

          for (let it in ep.routes) {
            if (ep.routes[it] === '/' + this.$route.params.module) {
              this.moduleName = it
              this.loaded = 1
              this.$emit('newLink', '/admin/' + this.$route.params.module + '/create')
              this.listLink = '/admin/' + this.$route.params.module + '/index'
              this.module = this.$route.params.module
            }
          }

          for (let it in res.data.data[this.moduleName].show_list) {
            if (res.data.data[this.moduleName].searchColumnLabels[res.data.data[this.moduleName].show_list[it]] !== undefined) {
              this.fields.push({
                name: res.data.data[this.moduleName].show_list[it],
                sortField: res.data.data[this.moduleName].show_list[it],
                title: this.$translate.t(res.data.data[this.moduleName].searchColumnLabels[res.data.data[this.moduleName].show_list[it]])
              })
            }
          }

          this.fields.push({
            name: '__slot:actions',
            title: this.$translate.t('Actions')
          })

          this.formClass = res.data.data.form
          this.panels = res.data.data.inputs

          this.$emit('activeMenu', this.moduleName)
        } else {
          this.$router.push('/admin/404')
        }
      }).catch(res => {
        this.$router.push('/admin/404')
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/custom/Custom.vue